export function groupById(array) {
  const byId = {};
  array.forEach(el => byId[el._id] = el);
  return byId;
}